import request from '@/utils/request';

// 新增广告列表
export function addAdvertising(params) {
  return request({
    url: `/education/training/website/adverts`,
    method: 'post',
    data: params
  });
}

// 编辑广告列表
export function editAdvertising(params) {
  return request({
    url: `/education/training/website/adverts`,
    method: 'put',
    data: params
  });
}

// 改变广告顺序
export function changeAdvertisingSeq(id, seq) {
  return request({
    url: `/education/training/website/adverts/${id}/seq/${seq}`,
    method: 'put'
  });
}

// 禁用广告
export function changeAdvertisingDisable(id) {
  return request({
    url: `/education/training/website/adverts/${id}/disable`,
    method: 'put'
  });
}
// 启用广告
export function changeAdvertisingEnable(id) {
  return request({
    url: `/education/training/website/adverts/${id}/enable`,
    method: 'put'
  });
}
// 删除广告
export function deleteAdvertising(id) {
  return request({
    url: `/education/training/website/adverts/${id}`,
    method: 'delete'
  });
}

// 查询分页列表
export function getAdvertisingPageList(params) {
  return request({
    url: `/education/training/website/adverts/page`,
    method: 'get',
    params: params
  });
}

// 获取详细信息
export function getAdvertisingDetail(id) {
  return request({
    url: `/education/training/website/adverts/${id}`,
    method: 'get'
  });
}

// ---------------------课程案例API----------------------------

// 创建课程案例
export function createTrainCourseCases(params) {
  return request({
    url: `/education/training/course/cases`,
    method: 'post',
    data: params
  });
}

// 修改排序号
export function changeCourseCasesSeq(id, seq) {
  return request({
    url: `/education/training/course/cases/${id}/seq/${seq}`,
    method: 'put'
  });
}

// 查询分页列表
export function getCourseCasesPageList(params) {
  return request({
    url: `/education/training/course/cases/page`,
    method: 'get',
    params: params
  });
}

// 更新课程案例
export function updateTrainCourseCases(id, params) {
  return request({
    url: `/education/training/course/cases/${id}`,
    method: 'put',
    data: params
  });
}

// 删除课程案例
export function deleteTrainCourseCases(id) {
  return request({
    url: `/education/training/course/cases/${id}`,
    method: 'delete'
  });
}

// 获取课程案例详情
export function getCourseCasesDetail(id) {
  return request({
    url: `/education/training/course/cases/${id}`,
    method: 'get'
  });
}
